


const CommaSeparatorHelper = (data, key, is_list = false) => {

    if(!is_list) {
        return (new Set(data[key].replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    }
    for(let i of data) {
        if(typeof i[key] != "string") {
            break;
        }
        i[key] = CommaSeparatorHelper(i, key);
    }

    return data
}



export default CommaSeparatorHelper;
